// extracted by mini-css-extract-plugin
export default {"container_about":"Contact_container_about__xUIt9","img_contact":"Contact_img_contact__6RnPC"};